import { Navigate } from 'react-router-dom'

/**
 * Legacy /volunteer-dashboard route. The Volunteer Community experience now
 * lives in the dedicated /community-dashboard shell (VOLUNTEER_COMMUNITY users
 * are routed there via `destinationForUserType`). This route is kept for
 * back-compat and redirects to the new shell.
 */
const VolunteerDashboard = () => <Navigate to="/community-dashboard" replace />

export default VolunteerDashboard